module.exports = "<div class=fbc-title-date-range><%=date%></div><span class=fbc-label><%=name%></span> <span class=fbc-value><%=value%></span>";